/**
 * Tooltip functunality
 * @module tooltip
 */

import $ from 'jquery';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
export const PLUGIN_NAME = 'tooltip';

export const DEFAULTS = {
  preventDefault: true,
  removeTooltipOnHover: false,
};


/**
 * Sends focus to the content container.
 * @param  {jQuery} $el - button /element that toggles text
 */
const scrollToView = ($el) => {
  const tooltipContent = '.js-tooltip-content';
  $el.find(tooltipContent).focus();
};
/**
 * Prevents default functunality on click
 * @param  {jQuery} $el - button /element that toggles text
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, opts) => {
  $el.on('click', (evt) => {
    if (opts.preventDefault === true) {
        evt.preventDefault();
    }
    scrollToView($el);
  });
  $('.js-tooltip-content').find('a').on('click', (e) => {
    e.stopPropagation();
  });

  // if Tooltip has data attribute data-remove-tooltip-hover
  const dataremoveTooltipOnHover = $el.data('remove-tooltip-on-hover'); // Accesses data-remove-tooltip-hover
  const removeTooltipOnHover = dataremoveTooltipOnHover !== undefined
    ? (dataremoveTooltipOnHover === true || dataremoveTooltipOnHover === "")
    : opts.removeTooltipOnHover;

  if (removeTooltipOnHover) {
    const tooltipContent = $el.find('.js-tooltip-content');
    // Show child tooltip when hovering over the parent
    $el.on('mouseenter', function() {
        tooltipContent.removeClass('js-remove-hover');

    });
    // Hide tooltip when the mouse leaves the parent area
    $el.on('mouseleave', function() {
        tooltipContent.addClass('js-remove-hover');

    });
    // MUST Hide when hovering OVER the tooltip itself
    tooltipContent.on('mouseenter', function(e) {
        e.stopPropagation(); // Prevents the event from bubbling up to the parent
        $(this).addClass('js-remove-hover');

    });
  }
};
/**
 * Initializes Header.
 * @param {HTMLElement} el - trigger
 * @param {Object} options - Options used for wiring up the modal
 * @see DEFAULTS
 */
export default function tooltip(el, options = {}) {
  const $el = $(el);
  const opts = mergeOptions(DEFAULTS, options, $el);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, tooltip);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/tooltip.js